module.exports = __webpack_public_path__ + "img/download-3-panel-2.d9dd498c.png";